import { render, staticRenderFns } from "./ChangeSVG.vue?vue&type=template&id=e60e1222"
import script from "./ChangeSVG.vue?vue&type=script&lang=js"
export * from "./ChangeSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports